import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
// import { Menu, LogOut, User } from "lucide-react";
import { useAuth } from "@/hooks/auth";
import { useToast } from "@/hooks/use-toast";
import { IconDashboard } from "@tabler/icons-react";
import { Sparkles, User, LogOut, ShieldCheck, Menu } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const AdminHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { signOut, userProfile } = useAuth();
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut();
      navigate("/auth");
    } catch (error) {
      console.error("Error during logout:", error);
      toast({
        title: "خطأ في تسجيل الخروج",
        description: "حدث خطأ أثناء تسجيل الخروج",
        variant: "destructive",
      });
    }
  };

  return (
    <header
      className="sticky top-0 z-50 border-b border-white/10 backdrop-blur-xl bg-gradient-to-r from-school-navy/95 via-school-blue/90 to-school-teal/85 shadow-lg"
      dir="rtl"
    >
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo and Site Name */}
          <div className="flex items-center gap-3">
            <div className="w-20 h-20 flex items-center justify-center rounded-tr-2xl rounded-bl-2xl overflow-hidden bg-white/10 backdrop-blur-sm shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-2xl hover:bg-white/20 cursor-pointer group">
              <img
                src="/lovable-uploads/08e2886d-fb17-4c42-b6e6-e6bcb705f477.png"
                alt="شعار حاضرون"
                className="w-full h-full object-contain transition-transform duration-300 group-hover:rotate-3"
              />
            </div>
            <div>
              <h1 className="text-xl font-bold text-white tracking-wide">
                منصة حاضرون التعليمية
              </h1>
              <p className="text-xs text-gray-200/90 font-medium bg-white/5 backdrop-blur-sm px-3 py-1 rounded-md mt-1 border border-white/10">
                نظام إدارة الحضور المدرسي
              </p>
              {userProfile?.role === "admin" && (
                <Badge className="bg-gradient-to-r from-yellow-400/90 to-orange-400/90 text-yellow-900 text-xs mt-2 flex items-center gap-1.5 w-fit px-2 py-1 rounded-lg shadow-lg border border-yellow-300/50">
                  <ShieldCheck className="w-3.5 h-3.5" />
                  <span className="hidden sm:inline font-semibold">
                    وضع المدير
                  </span>
                  <span className="sm:hidden font-semibold">مدير</span>
                </Badge>
              )}
            </div>
          </div>

          {/* Desktop Actions */}
          <div className="hidden md:flex items-center gap-3">
            <Link to={location.pathname === "/profile" ? "/" : "/profile"}>
              <Button
                variant="outline"
                size="sm"
                className="flex items-center gap-2 border-white/30 bg-white/10 text-white hover:bg-white/20 transition-all duration-300 backdrop-blur-sm px-4 py-2 rounded-xl shadow-lg hover:shadow-xl"
              >
                {location.pathname === "/profile" ? (
                  <IconDashboard className="h-4 w-4" />
                ) : (
                  <User className="h-4 w-4" />
                )}
                {location.pathname === "/profile"
                  ? "العودة للرئيسية"
                  : "الملف الشخصي"}
              </Button>
            </Link>
            <Button
              onClick={handleLogout}
              variant="outline"
              size="sm"
              className="flex items-center gap-2 border-white/30 bg-white/10 text-white hover:bg-white/20 transition-all duration-300 backdrop-blur-sm px-4 py-2 rounded-xl shadow-lg hover:shadow-xl"
            >
              <LogOut className="h-4 w-4" />
              تسجيل الخروج
            </Button>
          </div>

          {/* Mobile Menu */}
          <Sheet open={isOpen} onOpenChange={setIsOpen}>
            <SheetTrigger asChild className="md:hidden">
              <Button
                variant="outline"
                size="sm"
                className="border-white/30 hover:bg-white/10 backdrop-blur-sm p-2"
              >
                <Menu className="h-4 w-4 text-white stroke-2" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-80" dir="rtl">
              <div className="flex flex-col h-full">
                <div className="py-6 border-b">
                  <h2 className="text-lg font-semibold">إعدادات المدير</h2>
                </div>
                <nav className="flex-1 py-6">
                  <div className="space-y-2">
                    <Link
                      to="/profile"
                      onClick={() => setIsOpen(false)}
                      className="flex items-center gap-3 px-4 py-3 rounded-lg text-slate-700 hover:bg-slate-100 transition-colors"
                    >
                      <User className="h-5 w-5" />
                      الملف الشخصي
                    </Link>
                  </div>
                </nav>
                <div className="py-6 border-t">
                  <Button
                    onClick={handleLogout}
                    variant="outline"
                    className="w-full flex items-center gap-2 text-red-600 border-red-600 hover:bg-red-50"
                  >
                    <LogOut className="h-4 w-4" />
                    تسجيل الخروج
                  </Button>
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
